export const VolunteerExperienceList = [
    {
      organization: "Eksotika Prima",
      position: "Web Developer",
      duration: "August 2024 - September 2024",
      responsibilities: [
        `Developed and maintained a rub oil supplier website, showcasing products sourced from Makassar.`,
        `Managed digital marketing campaigns, focusing on targeted promotions near Danau Sunter and surrounding area.`,
        `Successfully converted promotional efforts into a sale, securing a customer through strategic marketing initiatives.`,
      ],
    },
    {
      organization: 'BNCC',
      position: 'Member',
      duration: '2022 - 2023',
      responsibilities: [
        'Gained hands-on experience in web development through active participation.'
      ]
    },
    {
      organization: 'HIMTI',
      position: 'Member',
      duration: '2022 - Present',
      responsibilities: [
        'Collaborated on projects and attended workshops to enhance computer science knowledge.'
      ]
    }
  ];